module.exports = __webpack_public_path__ + "static/media/arrow-bended-hero.14fd81ae.svg";